
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/opt/bitnami/canvaslms/ui/features/assignment-index/jst/IndexView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <h2 class=\"screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments.index_view.assignments", "Assignments", options)))
    + "\n  </h2>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <h1 class=\"screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments.index_view.assignments", "Assignments", options)))
    + "\n  </h1>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  
  return "\n  <div id=\"bulkEditRoot\"></div>\n";
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<div class=\"header-bar\">\n  <div class=\"header-bar-left ic-Form-control assignment-search\">\n    <div class=\"ic-Multi-input\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.HAS_GRADING_PERIODS), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <label for=\"search_term\" class=\"screenreader-only\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.search_for_assignment", "Search for Assignment", options) : helperMissing.call(depth0, "t", "assignments.index_view.search_for_assignment", "Search for Assignment", options)))
    + "\n      </label>\n      <input\n        class=\"ic-Input\"\n        id=\"search_term\"\n        name=\"search_term\"\n        type=\"search\"\n        value=\"\"\n        disabled\n        placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.search_for_assignment", "Search for Assignment", options) : helperMissing.call(depth0, "t", "assignments.index_view.search_for_assignment", "Search for Assignment", options)))
    + "\"\n      >\n    </div>\n  </div>\n\n  <div class=\"header-bar-right\">\n    ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.program(19, program19, data),fn:self.program(13, program13, data),data:data},helper ? helper.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), options) : helperMissing.call(depth0, "ifAny", ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n\n<div data-view=\"assignmentGroups\" class=\"item-group-container\" id=\"ag-list\"></div>\n<div id=\"copy-to-mount-point\" />\n<div id=\"send-to-mount-point\" />\n<div id=\"external-tool-mount-point\" />\n\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div tabindex=\"0\" class=\"drag_and_drop_warning screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "warning_for_improved_accessibility_of_reordering_a_5d0206c7", "Warning: for improved accessibility of reordering assignments and groups, please use the Move To Dialog option found in the menu.", options) : helperMissing.call(depth0, "t", "warning_for_improved_accessibility_of_reordering_a_5d0206c7", "Warning: for improved accessibility of reordering assignments and groups, please use the Move To Dialog option found in the menu.", options)))
    + "\n  </div>\n";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <select class=\"ic-Input\" id=\"grading_period_selector\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "select_a_grading_period_aab25483", "Select a Grading Period", options) : helperMissing.call(depth0, "t", "select_a_grading_period_aab25483", "Select a Grading Period", options)))
    + "\">\n          <option value=\"all\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "all_grading_periods_77974940", "All Grading Periods", options) : helperMissing.call(depth0, "t", "all_grading_periods_77974940", "All Grading Periods", options)))
    + "</option>\n          ";
  stack1 = helpers.each.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.active_grading_periods), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </select>\n      ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <option id=\"grading_period_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" value=\""
    + escapeExpression(((stack1 = (data == null || data === false ? data : data.index)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n          ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.QUIZ_LTI_ENABLED), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n        <button\n          class=\"btn Button\"\n          id=\"addGroup\"\n          title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_group", "Add Assignment Group", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_group", "Add Assignment Group", options)))
    + "'\n          aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_group", "Add Assignment Group", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_group", "Add Assignment Group", options)))
    + "'\n        ><i class=\"icon-plus\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.add_group", "Group", options) : helperMissing.call(depth0, "t", "assignments.index_view.add_group", "Group", options)))
    + "</i></button>\n\n        <a\n          href=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.URLS)),stack1 == null || stack1 === false ? stack1 : stack1.new_assignment_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n          class=\"new_assignment btn btn-primary icon-plus\"\n          title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_assignment", "Add Assignment", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_assignment", "Add Assignment", options)))
    + "'\n          aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_assignment", "Add Assignment", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_assignment", "Add Assignment", options)))
    + "'\n        >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.add_assignment", "Assignment", options) : helperMissing.call(depth0, "t", "assignments.index_view.add_assignment", "Assignment", options)))
    + "</a>\n      ";
  return buffer;
  }
function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <span class=\"new_quiz_lti_wrapper\">\n            <a\n              href=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.URLS)),stack1 == null || stack1 === false ? stack1 : stack1.new_assignment_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "?quiz_lti\"\n              class=\"new_quiz_lti btn icon-plus\"\n              title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_quiz_lti", "Add Quiz/Test", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_quiz_lti", "Add Quiz/Test", options)))
    + "'\n              aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.title_add_quiz_lti", "Add Quiz/Test", options) : helperMissing.call(depth0, "t", "assignments.index_view.title_add_quiz_lti", "Add Quiz/Test", options)))
    + "'\n            >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.index_view")
  },data:data},helper ? helper.call(depth0, "assignments.index_view.add_quiz_lti", "Quiz/Test", options) : helperMissing.call(depth0, "t", "assignments.index_view.add_quiz_lti", "Quiz/Test", options)))
    + "</a>\n          </span>\n        ";
  return buffer;
  }

function program17(depth0,data) {
  
  
  return "\n        <span id=\"settingsMountPoint\"></span>\n      ";
  }

function program19(depth0,data) {
  
  
  return "\n      <div data-view=\"showBy\"></div>\n    ";
  }

function program21(depth0,data) {
  
  
  return "\n  <form data-view=\"createGroup\" class=\"form-dialog\"></form>\n";
  }

function program23(depth0,data) {
  
  
  return "\n  <form data-view=\"assignmentSettings\" class=\"form-dialog\"></form>\n  <form data-view=\"assignmentSyncSettings\" class=\"form-dialog\"></form>\n";
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course_home), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.bulkEditMode), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  